import api from './api'; // axios instance

const SettingsService = {

// Create a new expense
  createExpense: async (expenseData) => {
    const token = localStorage.getItem('auth_token');
    const response = await api.post('/api/add-expense-categories', expenseData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  // Get all expense categories
  getExpenseCategories: async () => {
    const token = localStorage.getItem('auth_token');
    const response = await api.get('/api/list-expense-categories', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },  
  // Delete expense by ID
  deleteExpense: async (id) => {
    const token = localStorage.getItem('auth_token');
    const response = await api.delete(`/api/delete-expense-categories/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

// Create a new revenue
  createRevenue: async (revenueData) => {
    const token = localStorage.getItem('auth_token');
    const response = await api.post('/api/add-revenue-categories', revenueData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  // Get all expense revenue
  getRevenueCategories: async () => {
    const token = localStorage.getItem('auth_token');
    const response = await api.get('/api/list-revenue-categories', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },  
  // Delete revenue by ID
  deleteRevenue: async (id) => {
    const token = localStorage.getItem('auth_token');
    const response = await api.delete(`/api/delete-revenue-categories/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

// Create a new service
  createService: async (serviceData) => {
    const token = localStorage.getItem('auth_token');
    const response = await api.post('/api/add-service', serviceData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  // Get all services
  getServices: async () => {
    const token = localStorage.getItem('auth_token');
    const response = await api.get('/api/list-services', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },  
  // Delete service by ID
  deleteService: async (id) => {
    const token = localStorage.getItem('auth_token');
    const response = await api.delete(`/api/delete-service/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

};

export default SettingsService;